import React from 'react';

const LoadingCube = ({ smallVersion = false }) => {
  const data = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div className={`sk-cube-grid ${smallVersion && 'small'}`}>
      {data.map((i) => (
        <div key={`cube-${i}`} className={`sk-cube sk-cube${i}`}/>
      ))}
    </div>
  );
}

export default LoadingCube;
